import { TEditAppealRequest, TProduct } from '../type'

// удаление товара из объекта заявки
export const prepareAppealToProductDelete = (
  products: TProduct[],
  deletedProduct: TProduct | null,
  appeal: TEditAppealRequest,
) => {
  const filteredProducts = products
    .filter(product => product.id !== deletedProduct?.id)
    .map(productItem => {
      return {
        id: productItem.id,
        parameters:
          productItem?.parameters?.map(param => ({
            id: param.id,
            parameterValue: {
              value: param.parameterValue.value,
            },
          })) || [],
      }
    })

  const newAppeal = {
    uid: appeal.uid,
    orderId: appeal.orderId,
    products: filteredProducts,
  }

  return newAppeal
}
